import { render, staticRenderFns } from "./DataTitle.vue?vue&type=template&id=76f1a6c0&"
import script from "./DataTitle.vue?vue&type=script&lang=js&"
export * from "./DataTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports